module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "zcgl"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.titlestr))]), _vm._v(" "), _c('div', {
    staticClass: "sz"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.params.nr == 'index'),
      expression: "$route.params.nr=='index'"
    }],
    staticClass: "am-dropdown am-dropdown-flip",
    attrs: {
      "id": "doc-dropdown-js"
    }
  }, [_c('i', {
    staticClass: "am-icon-cog am-dropdown-toggle"
  }), _vm._v(" "), _c('ul', {
    staticClass: "am-dropdown-content"
  }, [_c('li', [_c('router-link', {
    staticClass: "first",
    attrs: {
      "to": {
        name: 'zcgl',
        params: {
          nr: 'resetpwd'
        }
      }
    }
  }, [_vm._v("密码重置")])], 1), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])])])])])])], 1), _vm._v(" "), _c(_vm.$route.params.nr, {
    tag: "component",
    staticClass: "wrapper min-height",
    on: {
      "update:titlestr": function (val) { return _vm.titlestr = val; }
    }
  }), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21313e85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/zcgl/zcgl.vue
// module id = 809
// module chunks = 2